import React, { useState, useEffect, useCallback } from 'react';
const API = 'https://api.botanix.in/api';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB', blueBorder:'#B8D0F0',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 dark:'#0F1E14',
};
const inr = n => '₹' + Number(Math.round(n)||0).toLocaleString('en-IN');
const todayStr = () => new Date().toISOString().slice(0,10);

// ── TODAY'S BOOKINGS / EVENTS (pulled from booking engine) ────────────────────
const TODAY_EVENTS = [
 {id:'BTX-1042',type:'Corporate Day Out',group:'ABC Technologies Pvt Ltd',pax:250,meal:'Full Day',breakfast:250,lunch:250,highTea:250,dinner:0,status:'Confirmed',arrival:'09:00',departure:'18:00'},
 {id:'BTX-1055',type:'School Picnic',group:'Green Valley School',pax:180,meal:'Lunch + High Tea',breakfast:0,lunch:180,highTea:180,dinner:0,status:'Confirmed',arrival:'10:00',departure:'16:00'},
 {id:'BTX-1044',type:'Room Stay',group:'Rahul Mehta + 1',pax:2,meal:'Breakfast + Dinner',breakfast:2,lunch:0,highTea:0,dinner:2,status:'Checked In',arrival:'—',departure:'—'},
 {id:'BTX-1058',type:'Day Walk-in',group:'Walk-in Guests',pax:35,meal:'Lunch Only',breakfast:0,lunch:35,highTea:0,dinner:0,status:'Active',arrival:'12:30',departure:'14:30'},
];

// ── PAX SUMMARY ───────────────────────────────────────────────────────────────
const paxByMeal = () => {
 return TODAY_EVENTS.reduce((acc, e) => ({
 breakfast: acc.breakfast + e.breakfast,
 lunch: acc.lunch + e.lunch,
 highTea: acc.highTea + e.highTea,
 dinner: acc.dinner + e.dinner,
 }), {breakfast:0,lunch:0,highTea:0,dinner:0});
};

// ── RECIPES (recipe explosion data) ──────────────────────────────────────────
const RECIPES = {
 buffet_veg_lunch: {
 name:'Veg Buffet Lunch',
 perPax: [
 {item:'Basmati Rice', qty:0.15, unit:'kg'},
 {item:'Toor Dal', qty:0.08, unit:'kg'},
 {item:'Paneer', qty:0.06, unit:'kg'},
 {item:'Tomatoes', qty:0.05, unit:'kg'},
 {item:'Onions', qty:0.04, unit:'kg'},
 {item:'Cooking Oil', qty:0.02, unit:'L'},
 {item:'Potatoes', qty:0.07, unit:'kg'},
 {item:'Wheat Flour', qty:0.10, unit:'kg'},
 {item:'Butter', qty:0.01, unit:'kg'},
 ]
 },
 breakfast: {
 name:'Continental + Indian Breakfast',
 perPax: [
 {item:'Eggs', qty:1.5, unit:'pcs'},
 {item:'Milk', qty:0.15, unit:'L'},
 {item:'Wheat Flour', qty:0.08, unit:'kg'},
 {item:'Butter', qty:0.015,unit:'kg'},
 {item:'Tea Leaves', qty:0.005,unit:'kg'},
 ]
 },
 high_tea: {
 name:'High Tea Snacks',
 perPax: [
 {item:'Wheat Flour', qty:0.06, unit:'kg'},
 {item:'Cooking Oil', qty:0.015,unit:'L'},
 {item:'Tea Leaves', qty:0.004,unit:'kg'},
 {item:'Milk', qty:0.12, unit:'L'},
 {item:'Sugar', qty:0.02, unit:'kg'},
 ]
 },
 dinner: {
 name:'Dinner Buffet',
 perPax: [
 {item:'Basmati Rice', qty:0.15, unit:'kg'},
 {item:'Toor Dal', qty:0.09, unit:'kg'},
 {item:'Paneer', qty:0.07, unit:'kg'},
 {item:'Tomatoes', qty:0.05, unit:'kg'},
 {item:'Onions', qty:0.04, unit:'kg'},
 {item:'Cooking Oil', qty:0.025,unit:'L'},
 {item:'Chicken', qty:0.08, unit:'kg'},
 ]
 }
};

// ── INVENTORY STOCK ────────────────────────────────────────────────────────────
const INITIAL_STOCK = [
 {id:1,name:'Basmati Rice', unit:'kg', stock:85, reorder:100, cost:95},
 {id:2,name:'Paneer', unit:'kg', stock:40, reorder:60, cost:320},
 {id:3,name:'Toor Dal', unit:'kg', stock:70, reorder:50, cost:120},
 {id:4,name:'Cooking Oil', unit:'L', stock:30, reorder:40, cost:145},
 {id:5,name:'Milk', unit:'L', stock:110, reorder:150, cost:62},
 {id:6,name:'Tomatoes', unit:'kg', stock:25, reorder:30, cost:40},
 {id:7,name:'Onions', unit:'kg', stock:50, reorder:40, cost:35},
 {id:8,name:'Chicken', unit:'kg', stock:20, reorder:25, cost:280},
 {id:9,name:'Potatoes', unit:'kg', stock:60, reorder:30, cost:28},
 {id:10,name:'Wheat Flour', unit:'kg', stock:45, reorder:50, cost:42},
 {id:11,name:'Sugar', unit:'kg', stock:30, reorder:20, cost:48},
 {id:12,name:'Tea Leaves', unit:'kg', stock:8, reorder:10, cost:380},
 {id:13,name:'Coffee Powder',unit:'kg', stock:5, reorder:5, cost:620},
 {id:14,name:'Butter', unit:'kg', stock:10, reorder:8, cost:480},
 {id:15,name:'Eggs', unit:'pcs', stock:200, reorder:150, cost:8},
];

// ── KDS ORDERS ────────────────────────────────────────────────────────────────
const INITIAL_KDS = [
 {id:'KDS-001',station:'Buffet Line A', type:'Buffet', table:'Event Hall', items:'Veg Buffet Lunch for 250 pax', time:'11:30',status:'In Progress',priority:'High'},
 {id:'KDS-002',station:'Main Kitchen', type:'A-la-carte', table:'Table T-05', items:'Dal Makhani x2, Butter Naan x4', time:'12:15',status:'New', priority:'Normal'},
 {id:'KDS-003',station:'In-Room Dining', type:'Room Service', table:'Room 204', items:'Veg Thali x2, Mango Lassi x2', time:'12:22',status:'New', priority:'High'},
 {id:'KDS-004',station:'Beverage Counter',type:'Bar', table:'Poolside', items:'Fresh Lime Soda x5, Coffee x3', time:'12:35',status:'New', priority:'Normal'},
 {id:'KDS-005',station:'High Tea Counter',type:'High Tea', table:'Lawn Area', items:'High Tea for 180 pax', time:'15:00',status:'Scheduled', priority:'High'},
 {id:'KDS-006',station:'Tandoor Station', type:'A-la-carte', table:'Table T-08', items:'Tandoori Chicken x2, Naan x6', time:'12:40',status:'New', priority:'Normal'},
 {id:'KDS-007',station:'Buffet Line B', type:'Buffet', table:'School Group', items:'Veg Buffet Lunch for 180 pax', time:'12:30',status:'New', priority:'High'},
];

// ── WASTAGE LOG ───────────────────────────────────────────────────────────────
const WASTAGE_LOG = [
 {id:1,date:todayStr(),item:'Paneer', expected:37.5, actual:39.2, wastage:1.7, reason:'Over-portioning', cost:544, meal:'Lunch'},
 {id:2,date:todayStr(),item:'Basmati Rice',expected:93.75,actual:96.0,wastage:2.25,reason:'Buffet leftover', cost:214, meal:'Lunch'},
 {id:3,date:todayStr(),item:'Chicken', expected:14.0, actual:15.5, wastage:1.5, reason:'Trim waste', cost:420, meal:'Dinner (prev)'},
];

// ── PURCHASE SUGGESTIONS ──────────────────────────────────────────────────────
function computeRequirements(pax, recipe) {
 return recipe.perPax.map(r => ({
 ...r,
 totalNeeded: Math.ceil(r.qty * pax * 1.05), // +5% buffer
 }));
}

// ── ATOMS ─────────────────────────────────────────────────────────────────────
const Card = ({children,style={}}) => <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.05)',...style}}>{children}</div>;
const SH = ({title,icon,color,bg,right}) => (
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 18px',borderBottom:`1px solid ${C.border}`,background:bg||'#F5F8F5',borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}><span style={{fontSize:18}}>{icon}</span><span style={{fontSize:14,fontWeight:700,color:color||C.text}}>{title}</span></div>
 {right}
 </div>
);
const Btn = ({children,onClick,variant='primary',style={},disabled}) => {
 const v={primary:{background:C.accent,color:'#fff',border:'none'},danger:{background:C.red,color:'#fff',border:'none'},ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`},outline:{background:'transparent',color:C.accent,border:`1px solid ${C.accent}`},light:{background:C.accentLight,color:C.accent,border:'none'},amber:{background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBorder}`},blue:{background:C.blueBg,color:C.blue,border:`1px solid ${C.blueBorder}`}};
 return <button onClick={onClick} disabled={disabled} style={{...v[variant]||v.primary,padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',opacity:disabled?.5:1,display:'inline-flex',alignItems:'center',gap:6,whiteSpace:'nowrap',...style}}>{children}</button>;
};
const Inp = ({label,value,onChange,type='text',opts,placeholder=''}) => {
 const base={width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',boxSizing:'border-box'};
 return (
 <div style={{marginBottom:12}}>
 {label&&<div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>{label}</div>}
 {opts?<select style={base} value={value} onChange={e=>onChange(e.target.value)}>{opts.map(o=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={o}>{o}</option>)}</select>
 :<input type={type} style={base} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}/>}
 </div>
 );
};
const Th = ({c,right}) => <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:right?'right':'left',background:'#F5F8F5',borderBottom:`1px solid ${C.border}`,whiteSpace:'nowrap'}}>{c}</th>;
const Td = ({children,style={}}) => <td style={{padding:'11px 14px',fontSize:13,borderBottom:`1px solid ${C.border}`,verticalAlign:'middle',...style}}>{children}</td>;
const KPI = ({label,value,icon,color,bg,sub,warn}) => (
 <Card style={{padding:16}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.07em',lineHeight:1.4}}>{label}</div>
 <div style={{width:30,height:30,borderRadius:8,background:bg||C.accentLight,display:'flex',alignItems:'center',justifyContent:'center',fontSize:15,flexShrink:0}}>{icon}</div>
 </div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:color||C.text,letterSpacing:'-.02em'}}>{value}</div>
 {sub&&<div style={{fontSize:11,color:C.text3,marginTop:3}}>{sub}</div>}
 {warn&&<div style={{fontSize:11,fontWeight:600,color:C.red,marginTop:3}}>{warn}</div>}
 </Card>
);
const Modal = ({title,onClose,children,width='680px'}) => (
 <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
 <Card style={{width,maxWidth:'100%',maxHeight:'92vh',overflow:'auto',padding:28,boxShadow:'0 24px 64px rgba(0,0,0,.2)'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:22}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:C.text}}>{title}</div>
 <button onClick={onClose} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,cursor:'pointer',color:C.text2,fontSize:16,display:'flex',alignItems:'center',justifyContent:'center'}}></button>
 </div>
 {children}
 </Card>
 </div>
);


// ── KITCHEN DASHBOARD ─────────────────────────────────────────────────────────
function KitchenDashboard({kdsOrders, setKdsOrders, stock}) {
 const pax = paxByMeal();
 const totalPax = Object.values(pax).reduce((a,b)=>a+b,0);
 const lowStock = stock.filter(i=>i.stock<i.reorder);
 const urgentKDS = kdsOrders.filter(o=>o.status==='New'&&o.priority==='High').length;

 const mealCards = [
 {meal:'Breakfast', pax:pax.breakfast, time:'07:30–10:00', color:C.amber, bg:C.amberBg, recipe:'breakfast'},
 {meal:'Lunch', pax:pax.lunch, time:'12:00–14:30', color:C.blue, bg:C.blueBg, recipe:'buffet_veg_lunch'},
 {meal:'High Tea', pax:pax.highTea, time:'15:00–16:30', color:C.teal, bg:C.tealBg, recipe:'high_tea'},
 {meal:'Dinner', pax:pax.dinner, time:'19:00–21:30', color:C.purple,bg:C.purpleBg,recipe:'dinner'},
 ];

 return (
 <div>
 {/* Hero */}
 <div style={{background:`linear-gradient(135deg,${C.dark},#1A2E1A)`,borderRadius:16,padding:'22px 28px',marginBottom:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:11,color:'rgba(255,255,255,.4)',textTransform:'uppercase',letterSpacing:'.12em',marginBottom:4}}>Kitchen Command — {todayStr()}</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:12,marginTop:14}}>
 {[['Today Total Pax',totalPax,'','rgba(58,175,88,.9)'],['KDS Orders',kdsOrders.length,'','rgba(255,255,255,.75)'],['Urgent Orders',urgentKDS,'','rgba(200,51,51,.9)'],['Low Stock',lowStock.length,'','rgba(212,132,15,.9)'],['Food Cost %','28.4%','','rgba(255,255,255,.7)'],['Events Today',TODAY_EVENTS.length,'','rgba(107,72,168,.8)']].map(([k,v,ic,c])=>(
 <div key={k} style={{padding:'14px',background:'rgba(255,255,255,.07)',borderRadius:12}}>
 <div style={{fontSize:18,marginBottom:6}}>{ic}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:22,fontWeight:800,color:c,marginBottom:2}}>{v}</div>
 <div style={{fontSize:10,color:'rgba(255,255,255,.4)',textTransform:'uppercase',letterSpacing:'.06em'}}>{k}</div>
 </div>
 ))}
 </div>
 </div>

 {/* Low stock alert */}
 {lowStock.length>0&&(
 <div style={{padding:'12px 18px',background:C.redBg,border:`1px solid ${C.redBorder}`,borderRadius:10,marginBottom:16,display:'flex',alignItems:'center',gap:10}}>
 <span style={{fontSize:18}}></span>
 <span style={{fontSize:13,color:C.red,fontWeight:600}}>Reorder Required: {lowStock.map(i=>i.name).join(', ')}</span>
 </div>
 )}

 {/* Meal pax cards */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14,marginBottom:20}}>
 {mealCards.map(mc=>(
 <Card key={mc.meal} style={{overflow:'hidden'}}>
 <div style={{height:4,background:mc.color}}/>
 <div style={{padding:'16px 18px'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
 <div>
 <div style={{fontSize:18,marginBottom:4}}>{mc.icon}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:mc.color}}>{mc.meal}</div>
 <div style={{fontSize:11,color:C.text3}}>{mc.time}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:28,fontWeight:800,color:mc.pax>0?C.text:C.text3}}>{mc.pax}</div>
 <div style={{fontSize:10,color:C.text3}}>pax</div>
 </div>
 </div>
 {mc.pax>0
 ?<div style={{fontSize:11,color:mc.color,fontWeight:600,padding:'5px 8px',background:mc.bg,borderRadius:7,textAlign:'center'}}>Production sheet ready</div>
 :<div style={{fontSize:11,color:C.text3,textAlign:'center'}}>No service</div>}
 </div>
 </Card>
 ))}
 </div>

 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
 {/* Today's events */}
 <Card>
 <SH title="Today's Events & Meal Plans" icon="" color={C.blue} bg={C.blueBg}/>
 <div style={{padding:'12px 18px',display:'flex',flexDirection:'column',gap:8}}>
 {TODAY_EVENTS.map(ev=>(
 <div key={ev.id} style={{padding:'12px 14px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
 <div>
 <div style={{fontWeight:700,fontSize:13,color:C.text}}>{ev.group}</div>
 <div style={{fontSize:11,color:C.text3}}>{ev.type} · {ev.pax} pax · {ev.arrival}–{ev.departure}</div>
 </div>
 <span style={{padding:'3px 9px',borderRadius:99,fontSize:10,fontWeight:600,color:ev.status==='Confirmed'||ev.status==='Checked In'?C.accent:ev.status==='Active'?C.blue:C.amber,background:ev.status==='Confirmed'||ev.status==='Checked In'?C.accentLight:ev.status==='Active'?C.blueBg:C.amberBg}}>{ev.status}</span>
 </div>
 <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
 {[['B',ev.breakfast,''],['L',ev.lunch,''],['HT',ev.highTea,''],['D',ev.dinner,'']].map(([k,v,ic])=>v>0&&(
 <span key={k} style={{padding:'2px 7px',borderRadius:6,fontSize:10,fontWeight:600,background:C.accentLight,color:C.accent}}>{ic} {v} pax</span>
 ))}
 </div>
 </div>
 ))}
 </div>
 </Card>

 {/* Live KDS Summary */}
 <Card>
 <SH title="Live KDS — Orders by Station" icon="" color={C.red} bg={C.redBg}/>
 <div style={{padding:'12px 18px',display:'flex',flexDirection:'column',gap:6}}>
 {[...new Set(kdsOrders.map(o=>o.station))].map(station=>{
 const orders = kdsOrders.filter(o=>o.station===station);
 const pending = orders.filter(o=>o.status!=='Done').length;
 return (
 <div key={station} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 13px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`}}>
 <div style={{flex:1}}>
 <div style={{fontWeight:600,fontSize:13,color:C.text}}>{station}</div>
 <div style={{fontSize:11,color:C.text3}}>{orders.length} orders · {pending} pending</div>
 </div>
 <div style={{display:'flex',gap:6}}>
 {orders.filter(o=>o.status==='New').length>0&&<span style={{padding:'2px 7px',borderRadius:99,fontSize:10,fontWeight:600,background:C.redBg,color:C.red}}>{orders.filter(o=>o.status==='New').length} new</span>}
 {orders.filter(o=>o.status==='In Progress').length>0&&<span style={{padding:'2px 7px',borderRadius:99,fontSize:10,fontWeight:600,background:C.amberBg,color:C.amber}}>{orders.filter(o=>o.status==='In Progress').length} active</span>}
 </div>
 </div>
 );
 })}
 </div>
 </Card>
 </div>

 {/* Food cost tracker */}
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Today's Food Cost Tracker</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:12}}>
 {[['F&B Revenue','₹1,42,500',C.accent],['Raw Material Cost','₹40,470',C.amber],['Food Cost %','28.4%',C.accent],['Vs Yesterday','28.1%',C.accent],['Target','30% max',C.accent]].map(([k,v,c])=>(
 <div key={k} style={{padding:'12px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`,textAlign:'center'}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',marginBottom:4}}>{k}</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:17,fontWeight:800,color:c}}>{v}</div>
 </div>
 ))}
 </div>
 </Card>
 </div>
 );
}

// ── PRODUCTION SHEET ──────────────────────────────────────────────────────────
function ProductionSheet({stock}) {

 const [kitchenToday, setKitchenToday] = React.useState(null);
 React.useEffect(()=>{
 fetch("https://api.botanix.in/api/notify/kitchen-today").then(r=>r.json()).then(d=>setKitchenToday(d)).catch(()=>{});
 },[]);
 const [selMeal, setSelMeal] = useState('lunch');
 const [customPax, setCustomPax] = useState(null);
 const [showAddItem, setShowAddItem] = useState(false);

 const pax = paxByMeal();
 const mealPax = {breakfast:pax.breakfast, lunch:pax.lunch, highTea:pax.highTea, dinner:pax.dinner};
 const recipeKey = {breakfast:'breakfast', lunch:'buffet_veg_lunch', highTea:'high_tea', dinner:'dinner'};
 const mealNames = {breakfast:'Breakfast', lunch:'Veg Buffet Lunch', highTea:'High Tea', dinner:'Dinner Buffet'};

 const activePax = customPax !== null ? customPax : (mealPax[selMeal]||0);
 const recipe = RECIPES[recipeKey[selMeal]];
 const requirements = recipe ? computeRequirements(activePax, recipe) : [];

 return (
 <div>
 <div style={{display:'flex',gap:8,marginBottom:20,flexWrap:'wrap',alignItems:'center'}}>
 {['breakfast','lunch','highTea','dinner'].map(m=>(
 <button key={m} onClick={()=>{setSelMeal(m);setCustomPax(null);}}
 style={{padding:'8px 16px',borderRadius:9,border:`1px solid ${selMeal===m?C.accent:C.border2}`,background:selMeal===m?C.accentLight:'transparent',color:selMeal===m?C.accent:C.text3,fontSize:13,fontWeight:600,cursor:'pointer'}}>
 {mealNames[m]} ({mealPax[m]||0} pax)
 </button>
 ))}
 <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
 <span style={{fontSize:12,color:C.text3}}>Override pax:</span>
 <input type="number" value={customPax||''} onChange={e=>setCustomPax(parseInt(e.target.value)||null)} placeholder="e.g. 300"
 style={{width:90,padding:'7px 10px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif'}}/>
 {customPax&&<Btn variant="ghost" style={{padding:'6px 10px',fontSize:11}} onClick={()=>setCustomPax(null)}>Reset</Btn>}
 </div>
 </div>

 {/* Production sheet header */}
 <Card style={{marginBottom:16}}>
 <div style={{padding:'16px 20px',background:`linear-gradient(135deg,${C.dark},#1A2E1A)`,borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
 <div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:18,fontWeight:800,color:'#fff'}}>Production Sheet — {mealNames[selMeal]}</div>
 <div style={{fontSize:12,color:'rgba(255,255,255,.5)',marginTop:4}}>{todayStr()} · Head Chef: Suresh Kumar</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:28,fontWeight:800,color:C.accent}}>{activePax} pax</div>
 {customPax&&<div style={{fontSize:11,color:C.amber}}>Custom override</div>}
 </div>
 </div>
 {/* Breakdown by booking */}
 <div style={{display:'flex',gap:8,marginTop:12,flexWrap:'wrap'}}>
 {TODAY_EVENTS.filter(e=>selMeal==='breakfast'?e.breakfast>0:selMeal==='lunch'?e.lunch>0:selMeal==='highTea'?e.highTea>0:e.dinner>0).map(ev=>(
 <span key={ev.id} style={{padding:'4px 10px',borderRadius:8,background:'rgba(255,255,255,.08)',color:'rgba(255,255,255,.7)',fontSize:11}}>
 {ev.group.split(' ')[0]}: {selMeal==='breakfast'?ev.breakfast:selMeal==='lunch'?ev.lunch:selMeal==='highTea'?ev.highTea:ev.dinner} pax
 </span>
 ))}
 </div>
 </div>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Sr"/><Th c="Ingredient"/><Th c="Per Pax"/><Th c="Unit"/><Th c={`Total Required (${activePax} pax)`}/><Th c="In Stock"/><Th c="Shortage"/><Th c="Status"/></tr></thead>
 <tbody>
 {requirements.map((r,i)=>{
 const stockItem = stock.find(s=>s.name===r.item);
 const inStock = stockItem?.stock||0;
 const shortage = Math.max(0, r.totalNeeded - inStock);
 const ok = shortage===0;
 return (
 <tr key={i} style={{borderBottom:`1px solid ${C.border}`,background:!ok?'#FFF8F5':C.surface}}>
 <Td style={{color:C.text3,width:40}}>{i+1}</Td>
 <Td><span style={{fontWeight:600}}>{r.item}</span></Td>
 <Td style={{color:C.text3}}>{r.qty} {r.unit}</Td>
 <Td style={{color:C.text3}}>{r.unit}</Td>
 <Td><span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:700,color:C.text}}>{r.totalNeeded}</span> <span style={{fontSize:11,color:C.text3}}>{r.unit}</span></Td>
 <Td><span style={{fontWeight:600,color:inStock>=r.totalNeeded?C.accent:C.red}}>{inStock} {r.unit}</span></Td>
 <Td><span style={{fontWeight:700,color:shortage>0?C.red:C.text3}}>{shortage>0?shortage+' '+r.unit:'—'}</span></Td>
 <Td>
 {ok
 ?<span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:C.accent,background:C.accentLight}}>OK</span>
 :<span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:C.red,background:C.redBg}}>Short {shortage} {r.unit}</span>}
 </Td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 {requirements.some(r=>Math.max(0,r.totalNeeded-(stock.find(s=>s.name===r.item)?.stock||0))>0)&&(
 <div style={{padding:'12px 18px',background:C.redBg,borderTop:`1px solid ${C.redBorder}`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{fontSize:13,color:C.red,fontWeight:600}}>Shortage detected — raise purchase order before service starts</div>
 <div style={{display:'flex',gap:8}}>
 <Btn variant="danger" style={{fontSize:11,padding:'5px 12px'}}>Generate PO</Btn>
 <Btn variant="ghost" style={{fontSize:11,padding:'5px 12px'}} onClick={()=>window.print()}>Print Sheet</Btn>
 </div>
 </div>
 )}
 </Card>

 {/* Summary across all meals */}
 <Card>
 <SH title="All Meals Summary — Today" icon="" color={C.blue} bg={C.blueBg}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Group"/><Th c="Type"/><Th c="Breakfast"/><Th c="Lunch"/><Th c="High Tea"/><Th c="Dinner"/><Th c="Total Pax"/></tr></thead>
 <tbody>
 {TODAY_EVENTS.map(ev=>(
 <tr key={ev.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <Td><span style={{fontWeight:600}}>{ev.group}</span></Td>
 <Td style={{fontSize:12,color:C.text3}}>{ev.type}</Td>
 <Td><span style={{fontWeight:ev.breakfast?600:400,color:ev.breakfast?C.accent:C.text3}}>{ev.breakfast||'—'}</span></Td>
 <Td><span style={{fontWeight:ev.lunch?600:400,color:ev.lunch?C.accent:C.text3}}>{ev.lunch||'—'}</span></Td>
 <Td><span style={{fontWeight:ev.highTea?600:400,color:ev.highTea?C.accent:C.text3}}>{ev.highTea||'—'}</span></Td>
 <Td><span style={{fontWeight:ev.dinner?600:400,color:ev.dinner?C.accent:C.text3}}>{ev.dinner||'—'}</span></Td>
 <Td><span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text}}>{ev.pax}</span></Td>
 </tr>
 ))}
 <tr style={{background:C.accentLight}}>
 <Td colSpan={2} style={{fontWeight:800}}>TOTAL</Td>
 {['breakfast','lunch','highTea','dinner'].map(m=>{
 const pax = paxByMeal();
 return <Td key={m}><span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.accent}}>{pax[m]}</span></Td>;
 })}
 <Td><span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text}}>{Object.values(paxByMeal()).reduce((a,b)=>a+b,0)}</span></Td>
 </tr>
 </tbody>
 </table>
 </div>
 </Card>
 </div>
 );
}

// ── KDS MODULE ────────────────────────────────────────────────────────────────
function KDSModule({kdsOrders, setKdsOrders}) {
 const [activeStation, setActiveStation] = useState('All');
 const [showForm, setShowForm] = useState(false);
 const [f, setF] = useState({station:'Main Kitchen',type:'A-la-carte',table:'',items:'',priority:'Normal'});

 const stations = ['All',...new Set(kdsOrders.map(o=>o.station))];
 const types = ['All','Buffet','A-la-carte','Room Service','Bar','High Tea'];
 const [filterType, setFilterType] = useState('All');

 const filtered = kdsOrders.filter(o=>(activeStation==='All'||o.station===activeStation)&&(filterType==='All'||o.type===filterType));

 const advance = (id) => {
 const order = ['New','In Progress','Ready','Done'];
 setKdsOrders(p=>p.map(o=>o.id===id?{...o,status:order[Math.min(order.indexOf(o.status)+1,3)]}:o));
 };

 const stationColors = {'Buffet Line A':C.accent,'Buffet Line B':C.blue,'Main Kitchen':C.red,'In-Room Dining':C.purple,'Beverage Counter':C.teal,'High Tea Counter':C.amber,'Tandoor Station':C.amber};
 const statusConfig = {New:{color:C.red,bg:C.redBg}, 'In Progress':{color:C.amber,bg:C.amberBg}, Ready:{color:C.accent,bg:C.accentLight}, Done:{color:C.text3,bg:C.border}};

 const newOrders = filtered.filter(o=>o.status==='New');
 const inProgress = filtered.filter(o=>o.status==='In Progress');
 const ready = filtered.filter(o=>o.status==='Ready');
 const done = filtered.filter(o=>o.status==='Done');

 const OrderCard = ({order}) => {
 const sc = statusConfig[order.status]||statusConfig.New;
 const sc2 = stationColors[order.station]||C.text3;
 return (
 <Card style={{marginBottom:10,border:`1px solid ${order.priority==='High'?C.red:C.border}`,overflow:'hidden'}}>
 {order.priority==='High'&&<div style={{height:3,background:C.red}}/>}
 <div style={{padding:'12px 14px'}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
 <div>
 <div style={{fontFamily:'monospace',fontSize:11,color:C.text3,marginBottom:3}}>{order.id}</div>
 <div style={{fontWeight:700,fontSize:13,color:C.text}}>{order.table}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <span style={{padding:'3px 8px',borderRadius:99,fontSize:10,fontWeight:600,color:sc.color,background:sc.bg,display:'block',marginBottom:4}}>{order.status}</span>
 <div style={{fontSize:11,color:C.text3}}>{order.time}</div>
 </div>
 </div>
 <div style={{fontSize:12,color:C.text2,marginBottom:10,lineHeight:1.5}}>{order.items}</div>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <div style={{display:'flex',gap:5}}>
 <span style={{padding:'2px 7px',borderRadius:6,fontSize:10,fontWeight:600,background:sc2+'15',color:sc2}}>{order.type}</span>
 {order.priority==='High'&&<span style={{padding:'2px 7px',borderRadius:6,fontSize:10,fontWeight:600,background:C.redBg,color:C.red}}>URGENT</span>}
 </div>
 {order.status!=='Done'&&<Btn onClick={()=>advance(order.id)} style={{padding:'5px 10px',fontSize:11}}>{order.status==='New'?'Start →':order.status==='In Progress'?'Ready ':'Served '}</Btn>}
 </div>
 </div>
 </Card>
 );
 };

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="New Orders" value={kdsOrders.filter(o=>o.status==='New').length} icon="" color={C.red} bg={C.redBg}/>
 <KPI label="In Progress" value={kdsOrders.filter(o=>o.status==='In Progress').length} icon="" color={C.amber} bg={C.amberBg}/>
 <KPI label="Ready to Serve" value={kdsOrders.filter(o=>o.status==='Ready').length} icon="" color={C.accent}/>
 <KPI label="Completed Today" value={kdsOrders.filter(o=>o.status==='Done').length} icon="" color={C.text3}/>
 </div>

 {/* Station filter */}
 <div style={{display:'flex',gap:6,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
 <span style={{fontSize:11,color:C.text3,fontWeight:600}}>STATION:</span>
 {stations.map(s=>(
 <button key={s} onClick={()=>setActiveStation(s)}
 style={{padding:'5px 12px',borderRadius:8,border:`1px solid ${activeStation===s?C.accent:C.border2}`,background:activeStation===s?C.accentLight:'transparent',color:activeStation===s?C.accent:C.text3,fontSize:11,fontWeight:600,cursor:'pointer'}}>
 {s}
 </button>
 ))}
 <span style={{fontSize:11,color:C.text3,fontWeight:600,marginLeft:8}}>TYPE:</span>
 {['All','Buffet','A-la-carte','Room Service','Bar','High Tea'].map(t=>(
 <button key={t} onClick={()=>setFilterType(t)}
 style={{padding:'5px 12px',borderRadius:8,border:`1px solid ${filterType===t?C.blue:C.border2}`,background:filterType===t?C.blueBg:'transparent',color:filterType===t?C.blue:C.text3,fontSize:11,fontWeight:600,cursor:'pointer'}}>
 {t}
 </button>
 ))}
 <div style={{marginLeft:'auto'}}>
 <Btn onClick={()=>setShowForm(!showForm)} style={{fontSize:11,padding:'6px 12px'}}>+ New Order</Btn>
 </div>
 </div>

 {showForm&&(
 <Card style={{padding:18,marginBottom:14,border:`1px solid ${C.accent}`}}>
 <div style={{fontWeight:700,fontSize:13,marginBottom:12}}>Add KDS Order</div>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10}}>
 <Inp label="Station" value={f.station} onChange={v=>setF(p=>({...p,station:v}))} opts={['Main Kitchen','Buffet Line A','Buffet Line B','In-Room Dining','Beverage Counter','High Tea Counter','Tandoor Station']}/>
 <Inp label="Order Type" value={f.type} onChange={v=>setF(p=>({...p,type:v}))} opts={['Buffet','A-la-carte','Room Service','Bar','High Tea']}/>
 <Inp label="Priority" value={f.priority} onChange={v=>setF(p=>({...p,priority:v}))} opts={['Normal','High']}/>
 <Inp label="Table / Room / Group" value={f.table} onChange={v=>setF(p=>({...p,table:v}))} placeholder="e.g. Table T-05"/>
 </div>
 <Inp label="Items" value={f.items} onChange={v=>setF(p=>({...p,items:v}))} placeholder="e.g. Dal Makhani x2, Naan x4"/>
 <div style={{display:'flex',gap:8}}>
 <Btn onClick={()=>{if(!f.table||!f.items)return;setKdsOrders(p=>[{id:`KDS-${String(p.length+1).padStart(3,'0')}`,time:new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}),status:'New',...f},...p]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Add to KDS</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Card>
 )}

 {/* Kanban columns */}
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14}}>
 {[[' New',newOrders,C.red],[' In Progress',inProgress,C.amber],[' Ready',ready,C.accent],[' Done',done,C.text3]].map(([title,orders,color])=>(
 <div key={title}>
 <div style={{padding:'8px 12px',background:color+'15',borderRadius:9,marginBottom:10,border:`1px solid ${color}33`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <span style={{fontSize:13,fontWeight:700,color}}>{title}</span>
 <span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color}}>{orders.length}</span>
 </div>
 {orders.map(o=><OrderCard key={o.id} order={o}/>)}
 {orders.length===0&&<div style={{padding:'20px',textAlign:'center',color:C.text3,fontSize:12,background:C.bg,borderRadius:9,border:`1px dashed ${C.border2}`}}>No orders</div>}
 </div>
 ))}
 </div>
 </div>
 );
}


// ── INVENTORY MANAGEMENT ──────────────────────────────────────────────────────
function KitchenInventory({stock, setStock}) {
 const [showForm, setShowForm] = useState(false);
 const [f, setF] = useState({name:'',unit:'kg',stock:'',reorder:'',cost:''});
 const [filter, setFilter] = useState('All');
 const lowStock = stock.filter(i=>i.stock<i.reorder);

 const cats = ['All','OK','Low Stock'];
 const filtered = filter==='All'?stock:filter==='OK'?stock.filter(i=>i.stock>=i.reorder):stock.filter(i=>i.stock<i.reorder);

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Items" value={stock.length} icon="" color={C.text}/>
 <KPI label="In Stock OK" value={stock.filter(i=>i.stock>=i.reorder).length} icon="" color={C.accent}/>
 <KPI label="Low / Reorder" value={lowStock.length} icon="" color={lowStock.length>0?C.red:C.accent} bg={lowStock.length>0?C.redBg:C.accentLight}/>
 <KPI label="Est. Stock Value" value={inr(stock.reduce((s,i)=>s+(i.stock*i.cost),0))} icon="" color={C.accent}/>
 </div>

 {lowStock.length>0&&(
 <div style={{padding:'12px 18px',background:C.redBg,border:`1px solid ${C.redBorder}`,borderRadius:10,marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
 <span style={{fontSize:13,color:C.red,fontWeight:600}}> Reorder Required: {lowStock.map(i=>`${i.name} (${i.stock}${i.unit})`).join(' · ')}</span>
 <Btn variant="danger" style={{fontSize:11,padding:'5px 12px'}}>Generate PO</Btn>
 </div>
 )}

 <div style={{display:'flex',gap:8,marginBottom:14}}>
 {cats.map(c=><button key={c} onClick={()=>setFilter(c)} style={{padding:'6px 14px',borderRadius:8,border:`1px solid ${filter===c?C.accent:C.border2}`,background:filter===c?C.accentLight:'transparent',color:filter===c?C.accent:C.text3,fontSize:12,fontWeight:600,cursor:'pointer'}}>{c}</button>)}
 <div style={{marginLeft:'auto'}}><Btn onClick={()=>setShowForm(!showForm)} style={{fontSize:12,padding:'6px 14px'}}>+ Add Item</Btn></div>
 </div>

 {showForm&&(
 <Card style={{padding:18,marginBottom:14,border:`1px solid ${C.accent}`}}>
 <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:10}}>
 <Inp label="Item Name" value={f.name} onChange={v=>setF(p=>({...p,name:v}))} placeholder="e.g. Paneer"/>
 <Inp label="Unit" value={f.unit} onChange={v=>setF(p=>({...p,unit:v}))} opts={['kg','L','pcs','g','dozen']}/>
 <Inp label="Current Stock" value={f.stock} onChange={v=>setF(p=>({...p,stock:v}))} type="number"/>
 <Inp label="Reorder Level" value={f.reorder} onChange={v=>setF(p=>({...p,reorder:v}))} type="number"/>
 <Inp label="Cost per unit (Rs.)" value={f.cost} onChange={v=>setF(p=>({...p,cost:v}))} type="number"/>
 </div>
 <div style={{display:'flex',gap:8}}>
 <Btn onClick={()=>{if(!f.name)return;setStock(p=>[...p,{id:Date.now(),name:f.name,unit:f.unit,stock:parseFloat(f.stock)||0,reorder:parseFloat(f.reorder)||0,cost:parseFloat(f.cost)||0}]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Add Item</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Card>
 )}

 <Card>
 <SH title="Ingredient Stock Register" icon="" color={C.accent} bg={C.accentLight}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Ingredient"/><Th c="Current Stock"/><Th c="Reorder Level"/><Th c="Unit Cost"/><Th c="Stock Value" right/><Th c="Status"/><Th c="Adjust"/></tr></thead>
 <tbody>
 {filtered.map(item=>{
 const low = item.stock<item.reorder;
 return (
 <tr key={item.id} style={{borderBottom:`1px solid ${C.border}`,background:low?'#FFF8F5':C.surface}}>
 <Td><span style={{fontWeight:600}}>{item.name}</span></Td>
 <Td><span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:700,color:low?C.red:C.accent}}>{item.stock}</span> <span style={{fontSize:11,color:C.text3}}>{item.unit}</span></Td>
 <Td style={{color:C.text3}}>{item.reorder} {item.unit}</Td>
 <Td style={{color:C.text3}}>{inr(item.cost)}/{item.unit}</Td>
 <Td style={{textAlign:'right',fontWeight:600}}>{inr(item.stock*item.cost)}</Td>
 <Td>{low?<span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:C.red,background:C.redBg}}>Reorder</span>:<span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:C.accent,background:C.accentLight}}>OK</span>}</Td>
 <Td>
 <div style={{display:'flex',gap:5}}>
 <button onClick={()=>setStock(p=>p.map(i=>i.id===item.id?{...i,stock:Math.max(0,i.stock-5)}:i))}
 style={{width:26,height:26,borderRadius:7,border:`1px solid ${C.border2}`,background:'transparent',color:C.text,cursor:'pointer',fontSize:14}}></button>
 <button onClick={()=>setStock(p=>p.map(i=>i.id===item.id?{...i,stock:i.stock+10}:i))}
 style={{width:26,height:26,borderRadius:7,border:`1px solid ${C.accent}`,background:C.accentLight,color:C.accent,cursor:'pointer',fontSize:14}}>+</button>
 <span style={{fontSize:10,color:C.text3,alignSelf:'center'}}>{item.unit}</span>
 </div>
 </Td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 </Card>
 </div>
 );
}

// ── WASTAGE & VARIANCE ────────────────────────────────────────────────────────
function WastageVariance() {
 const [wastage, setWastage] = useState(WASTAGE_LOG);
 const [showForm, setShowForm] = useState(false);
 const [f, setF] = useState({item:'',expected:'',actual:'',reason:'Over-portioning',meal:'Lunch',cost:''});
 const totalWastage = wastage.reduce((s,w)=>s+w.cost,0);

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total Wastage Cost" value={inr(totalWastage)} icon="" color={C.red} bg={C.redBg}/>
 <KPI label="Wastage Items" value={wastage.length} icon="" color={C.amber} bg={C.amberBg}/>
 <KPI label="Avg per Item" value={inr(Math.round(totalWastage/Math.max(wastage.length,1)))} icon="" color={C.text}/>
 <KPI label="Target Wastage" value="< ₹1,000/day" icon="" color={C.accent}/>
 </div>

 {totalWastage>1000&&(
 <div style={{padding:'12px 16px',background:C.redBg,border:`1px solid ${C.redBorder}`,borderRadius:10,marginBottom:16}}>
 <span style={{fontSize:13,color:C.red,fontWeight:600}}> Wastage exceeds daily target! Review portioning and production quantities.</span>
 </div>
 )}

 <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
 <Btn onClick={()=>setShowForm(!showForm)} style={{fontSize:12,padding:'6px 14px'}}>+ Log Wastage</Btn>
 </div>

 {showForm&&(
 <Card style={{padding:18,marginBottom:14,border:`1px solid ${C.amber}`}}>
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10}}>
 <Inp label="Ingredient" value={f.item} onChange={v=>setF(p=>({...p,item:v}))} placeholder="e.g. Paneer"/>
 <Inp label="Expected (kg/L/pcs)" value={f.expected} onChange={v=>setF(p=>({...p,expected:v}))} type="number"/>
 <Inp label="Actual Used" value={f.actual} onChange={v=>setF(p=>({...p,actual:v}))} type="number"/>
 <Inp label="Reason" value={f.reason} onChange={v=>setF(p=>({...p,reason:v}))} opts={['Over-portioning','Buffet leftover','Trim waste','Spoilage','Spillage','Recipe error']}/>
 <Inp label="Meal" value={f.meal} onChange={v=>setF(p=>({...p,meal:v}))} opts={['Breakfast','Lunch','High Tea','Dinner']}/>
 <Inp label="Wastage Cost (Rs.)" value={f.cost} onChange={v=>setF(p=>({...p,cost:v}))} type="number"/>
 </div>
 <div style={{display:'flex',gap:8}}>
 <Btn onClick={()=>{if(!f.item)return;const waste=parseFloat(f.actual||0)-parseFloat(f.expected||0);setWastage(p=>[{id:Date.now(),date:todayStr(),wastage:Math.max(0,waste),...f,expected:parseFloat(f.expected)||0,actual:parseFloat(f.actual)||0,cost:parseFloat(f.cost)||0},...p]);setShowForm(false);}} style={{flex:1,justifyContent:'center'}}>Log Wastage</Btn>
 <Btn variant="ghost" onClick={()=>setShowForm(false)} style={{flex:1,justifyContent:'center'}}>Cancel</Btn>
 </div>
 </Card>
 )}

 <Card>
 <SH title="Wastage & Variance Log" icon="" color={C.amber} bg={C.amberBg}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Date"/><Th c="Meal"/><Th c="Ingredient"/><Th c="Expected"/><Th c="Actual Used"/><Th c="Wastage"/><Th c="Reason"/><Th c="Cost" right/></tr></thead>
 <tbody>
 {wastage.map(w=>(
 <tr key={w.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <Td style={{color:C.text3,fontSize:12}}>{w.date}</Td>
 <Td><span style={{padding:'2px 8px',borderRadius:6,fontSize:11,fontWeight:600,background:C.amberBg,color:C.amber}}>{w.meal}</span></Td>
 <Td><span style={{fontWeight:600}}>{w.item}</span></Td>
 <Td style={{color:C.text3}}>{w.expected} kg</Td>
 <Td style={{color:C.amber}}>{w.actual} kg</Td>
 <Td><span style={{fontWeight:700,color:C.red}}>{w.wastage.toFixed(2)} kg</span></Td>
 <Td style={{fontSize:12,color:C.text3}}>{w.reason}</Td>
 <Td style={{textAlign:'right',fontWeight:700,color:C.red}}>{inr(w.cost)}</Td>
 </tr>
 ))}
 <tr style={{background:C.amberBg}}>
 <Td colSpan={7} style={{fontWeight:800}}>Total Wastage Cost Today</Td>
 <Td style={{textAlign:'right',fontWeight:800,fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,color:C.red}}>{inr(totalWastage)}</Td>
 </tr>
 </tbody>
 </table>
 </div>
 </Card>
 </div>
 );
}

// ── PURCHASE ORDERS ───────────────────────────────────────────────────────────
function PurchaseOrders({stock}) {
 const [pos, setPOs] = useState([
 {id:'PO-2001',vendor:'Fresh Farm Suppliers',date:todayStr(),items:[{name:'Paneer',qty:30,unit:'kg',rate:320,amount:9600},{name:'Milk',qty:100,unit:'L',rate:62,amount:6200}],total:15800,status:'Pending'},
 {id:'PO-2002',vendor:'Grain Masters',date:todayStr(),items:[{name:'Basmati Rice',qty:50,unit:'kg',rate:95,amount:4750},{name:'Toor Dal',qty:25,unit:'kg',rate:120,amount:3000}],total:7750,status:'Approved'},
 ]);
 const [showForm, setShowForm] = useState(false);
 const [f, setF] = useState({vendor:'Fresh Farm Suppliers',item:'',qty:'',unit:'kg',rate:''});

 const shortages = stock.filter(i=>i.stock<i.reorder).map(i=>({...i,needed:i.reorder-i.stock+i.reorder*0.2}));

 return (
 <div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
 <KPI label="Total POs Today" value={pos.length} icon="" color={C.text}/>
 <KPI label="Pending Approval" value={pos.filter(p=>p.status==='Pending').length} icon="" color={C.amber} bg={C.amberBg}/>
 <KPI label="Approved" value={pos.filter(p=>p.status==='Approved').length} icon="" color={C.accent}/>
 <KPI label="Total PO Value" value={inr(pos.reduce((s,p)=>s+p.total,0))} icon="" color={C.accent}/>
 </div>

 {/* Auto-suggested POs from shortage */}
 {shortages.length>0&&(
 <Card style={{marginBottom:16,border:`1px solid ${C.amberBorder}`}}>
 <SH title="AI Purchase Suggestions — Based on Today's Shortages" icon="" color={C.amber} bg={C.amberBg}/>
 <div style={{padding:18}}>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Ingredient"/><Th c="Current Stock"/><Th c="Reorder Level"/><Th c="Suggest Qty"/><Th c="Est. Cost"/><Th c="Action"/></tr></thead>
 <tbody>
 {shortages.map(s=>(
 <tr key={s.id} style={{borderBottom:`1px solid ${C.border}`}}>
 <Td><span style={{fontWeight:600}}>{s.name}</span></Td>
 <Td><span style={{color:C.red,fontWeight:600}}>{s.stock} {s.unit}</span></Td>
 <Td style={{color:C.text3}}>{s.reorder} {s.unit}</Td>
 <Td><span style={{fontWeight:700,color:C.amber}}>{Math.ceil(s.needed)} {s.unit}</span></Td>
 <Td style={{fontWeight:600}}>{inr(Math.ceil(s.needed)*s.cost)}</Td>
 <Td><Btn variant="amber" style={{fontSize:11,padding:'4px 10px'}}>Add to PO</Btn></Td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 <div style={{marginTop:12,display:'flex',gap:8}}>
 <Btn style={{fontSize:12}} onClick={()=>setPOs(p=>[{id:`PO-${2000+p.length+1}`,vendor:'Auto Suggested',date:todayStr(),items:shortages.map(s=>({name:s.name,qty:Math.ceil(s.needed),unit:s.unit,rate:s.cost,amount:Math.ceil(s.needed)*s.cost})),total:shortages.reduce((s,i)=>s+Math.ceil(i.needed)*i.cost,0),status:'Pending'},...p])}>Generate PO for All Shortages</Btn>
 <Btn variant="ghost" style={{fontSize:12}}>Export to PDF</Btn>
 </div>
 </div>
 </Card>
 )}

 {/* PO List */}
 <Card>
 <SH title="Purchase Orders" icon="" color={C.blue} bg={C.blueBg}
 right={<Btn style={{padding:'5px 12px',fontSize:11}} onClick={()=>setShowForm(!showForm)}>+ New PO</Btn>}/>
 <div style={{padding:18,display:'flex',flexDirection:'column',gap:12}}>
 {pos.map(po=>(
 <div key={po.id} style={{padding:'16px',background:C.bg,borderRadius:10,border:`1px solid ${C.border}`}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
 <div>
 <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
 <span style={{fontFamily:'monospace',fontSize:12,color:C.blue,fontWeight:700}}>{po.id}</span>
 <span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:po.status==='Approved'?C.accent:C.amber,background:po.status==='Approved'?C.accentLight:C.amberBg}}>{po.status}</span>
 </div>
 <div style={{fontWeight:600,fontSize:14,color:C.text}}>{po.vendor}</div>
 <div style={{fontSize:12,color:C.text3}}>{po.date}</div>
 </div>
 <div style={{textAlign:'right'}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.accent}}>{inr(po.total)}</div>
 <div style={{fontSize:11,color:C.text3}}>{po.items.length} items</div>
 </div>
 </div>
 <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:10}}>
 {po.items.map((it,i)=><span key={i} style={{padding:'3px 9px',borderRadius:6,fontSize:11,background:C.surface,border:`1px solid ${C.border}`,color:C.text2}}>{it.name}: {it.qty} {it.unit} @ {inr(it.rate)}</span>)}
 </div>
 {po.status==='Pending'&&(
 <div style={{display:'flex',gap:6}}>
 <Btn onClick={()=>setPOs(p=>p.map(x=>x.id===po.id?{...x,status:'Approved'}:x))} style={{fontSize:11,padding:'4px 10px'}}>Approve PO</Btn>
 <Btn variant="ghost" style={{fontSize:11,padding:'4px 10px'}}>Edit</Btn>
 <Btn variant="danger" style={{fontSize:11,padding:'4px 10px'}} onClick={()=>setPOs(p=>p.filter(x=>x.id!==po.id))}>Cancel</Btn>
 </div>
 )}
 </div>
 ))}
 </div>
 </Card>
 </div>
 );
}

// ── CHEF-FARM LINK ────────────────────────────────────────────────────────────
function ChefFarmLink() {
 const farmItems = [
 {crop:'Cherry Tomatoes',zone:'Greenhouse G',harvest:'Today',qty:58,kitchenNeed:20,status:'Ready to Harvest',color:C.accent},
 {crop:'Lettuce (Hydro)',zone:'NFT Bay A1',harvest:'6 days',qty:48,kitchenNeed:18,status:'Ready in 6 days',color:C.blue},
 {crop:'Mint',zone:'Kitchen Garden D',harvest:'Today',qty:16,kitchenNeed:12,status:'Harvested',color:C.teal},
 {crop:'Spinach',zone:'Kitchen Garden D',harvest:'Today',qty:34,kitchenNeed:28,status:'Ready to Harvest',color:C.accent},
 {crop:'Cucumber',zone:'Veg Farm B',harvest:'Today',qty:42,kitchenNeed:35,status:'Harvested',color:C.accent},
 {crop:'Microgreens',zone:'Greenhouse G',harvest:'Today',qty:6,kitchenNeed:6,status:'Pending',color:C.amber},
 ];
 const specialRequests = [
 {chef:'Head Chef Suresh',request:'Need 10kg extra Coriander for Saturday wedding',crop:'Coriander',qty:10,byDate:'2026-07-05',status:'Pending'},
 {chef:'Head Chef Suresh',request:'Microgreens for new menu item — need minimum 3kg/week',crop:'Microgreens',qty:3,byDate:'Ongoing',status:'Approved'},
 ];

 return (
 <div>
 <div style={{padding:'14px 18px',background:C.accentLight,border:`1px solid ${C.accent}33`,borderRadius:10,marginBottom:20,display:'flex',gap:10,alignItems:'center'}}>
 <span style={{fontSize:20}}></span>
 <span style={{fontSize:13,color:C.accent,fontWeight:500}}>Live link to BAHMS Horticulture System — today's harvest data, farm-to-kitchen supply chain visible in real time</span>
 </div>

 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
 {/* Today's farm harvest for kitchen */}
 <Card>
 <SH title="Today's Farm Harvest — Available for Kitchen" icon="" color={C.accent} bg={C.accentLight}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead><tr><Th c="Crop"/><Th c="Zone"/><Th c="Harvest"/><Th c="Available"/><Th c="Kitchen Need"/><Th c="Status"/></tr></thead>
 <tbody>
 {farmItems.map(item=>(
 <tr key={item.crop} style={{borderBottom:`1px solid ${C.border}`}}>
 <Td><span style={{fontWeight:600}}>{item.crop}</span></Td>
 <Td style={{fontSize:12,color:C.text3}}>{item.zone}</Td>
 <Td style={{fontSize:12,color:item.harvest==='Today'?C.accent:C.amber}}>{item.harvest}</Td>
 <Td><span style={{fontWeight:700,color:item.color}}>{item.qty} kg</span></Td>
 <Td><span style={{color:C.text3}}>{item.kitchenNeed} kg</span></Td>
 <Td><span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:item.status==='Harvested'?C.accent:item.status==='Ready to Harvest'?C.blue:item.status.includes('days')?C.amber:C.text3,background:item.status==='Harvested'?C.accentLight:item.status==='Ready to Harvest'?C.blueBg:item.status.includes('days')?C.amberBg:C.border}}>{item.status}</span></Td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>

 {/* Chef to farm requests */}
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Chef-to-Farm Special Requests</div>
 {specialRequests.map((r,i)=>(
 <div key={i} style={{padding:'14px',background:C.bg,borderRadius:9,border:`1px solid ${C.border}`,marginBottom:10}}>
 <div style={{fontWeight:600,fontSize:13,color:C.text,marginBottom:4}}>{r.request}</div>
 <div style={{display:'flex',gap:12,fontSize:12,color:C.text3,marginBottom:8}}>
 <span>Crop: {r.crop}</span><span>Qty: {r.qty} kg</span><span>By: {r.byDate}</span>
 </div>
 <span style={{padding:'3px 9px',borderRadius:99,fontSize:11,fontWeight:600,color:r.status==='Approved'?C.accent:C.amber,background:r.status==='Approved'?C.accentLight:C.amberBg}}>{r.status}</span>
 </div>
 ))}
 <Btn style={{width:'100%',justifyContent:'center',marginTop:8}}>+ New Request to Farm Team</Btn>
 </Card>
 </div>

 {/* QR Traceability */}
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}>Farm-to-Table QR Traceability</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
 {[{crop:'Cherry Tomatoes',zoneId:'Zone G',planted:'15 May 2026',harvested:'2 July 2026',method:'Organic + IPM',co2:'1.2 kg saved'},
 {crop:'Spinach',zoneId:'Zone D',planted:'1 June 2026',harvested:'2 July 2026',method:'Organic',co2:'0.6 kg saved'},
 {crop:'Mint',zoneId:'Zone D',planted:'20 May 2026',harvested:'2 July 2026',method:'Organic',co2:'0.3 kg saved'}].map(item=>(
 <div key={item.crop} style={{padding:'14px',background:C.accentLight,borderRadius:10,border:`1px solid ${C.accent}33`}}>
 <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
 <div style={{fontWeight:700,fontSize:13,color:C.accent}}>{item.crop}</div>
 <div style={{width:36,height:36,background:'#006b3c',borderRadius:7,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}></div>
 </div>
 {[['Zone',item.zoneId],['Planted',item.planted],['Harvested',item.harvested],['Method',item.method],['CO',item.co2]].map(([k,v])=>(
 <div key={k} style={{display:'flex',justifyContent:'space-between',fontSize:11,padding:'3px 0',borderBottom:`1px solid ${C.accent}22`}}>
 <span style={{color:C.text3}}>{k}</span><span style={{fontWeight:500,color:C.text}}>{v}</span>
 </div>
 ))}
 <div style={{marginTop:8,fontSize:11,color:C.accent,fontWeight:600,textAlign:'center'}}>Scan for full story</div>
 </div>
 ))}
 </div>
 </Card>
 </div>
 );
}

// ── MAIN MODULE ───────────────────────────────────────────────────────────────
const KM_TABS = [
 {id:'dashboard', label:'Kitchen Dashboard', },
 {id:'production', label:'Production Sheet', },
 {id:'kds', label:'KDS — Live Orders', },
 {id:'inventory', label:'Inventory & Stock', },
 {id:'wastage', label:'Wastage & Variance', },
 {id:'purchase', label:'Purchase Orders', },
 {id:'farm', label:'Chef-Farm Link', },
];

export default function KitchenManagement() {
 const [tab, setTab] = useState('dashboard');
 const [stock, setStock] = useState(INITIAL_STOCK);
 const [kdsOrders, setKdsOrders] = useState(INITIAL_KDS);
 const [liveEvents, setLiveEvents] = useState(null);

 useEffect(() => {
 fetch(`${API}/kitchen/meal-plan`)
 .then(r => r.json())
 .then(d => { if (d.bookings) setLiveEvents(d.bookings); })
 .catch(() => {});
 fetch(`${API}/kitchen/orders`)
 .then(r => r.json())
 .then(d => { if (Array.isArray(d) && d.length > 0) {
 setKdsOrders(d.map(o => ({
 id: o.order_number, station: o.station || 'Main Kitchen',
 type: o.order_type, table: o.table_number || 'N/A',
 items: o.items?.filter(i=>i.item_name).map(i=>`${i.item_name} x${i.quantity}`).join(', ') || 'Order',
 time: new Date(o.created_at).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}),
 status: o.status, priority: 'Normal'
 })));
 }})
 .catch(() => {});
 fetch(`${API}/inventory`)
 .then(r => r.json())
 .then(d => { if (Array.isArray(d) && d.length > 0) {
 setStock(d.map(i => ({
 id: i.id, name: i.item_name, unit: i.unit,
 stock: parseFloat(i.current_stock || 0),
 reorder: parseFloat(i.reorder_level || 0),
 cost: parseFloat(i.average_cost || 0)
 })));
 }})
 .catch(() => {});
 }, []);

 const newKDS = kdsOrders.filter(o=>o.status==='New').length;
 const lowStock = stock.filter(i=>i.stock<i.reorder).length;

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text}}>
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:62}}>
 <div>
 <div style={{fontSize:11,color:C.text3,fontWeight:500,marginBottom:1}}>F&B Operations</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text,letterSpacing:'-.02em'}}>Kitchen Management System</div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 {lowStock>0&&<div style={{padding:'7px 14px',background:C.redBg,borderRadius:9,border:`1px solid ${C.redBorder}`}}><span style={{fontSize:12,fontWeight:700,color:C.red}}>{lowStock} Items Low Stock</span></div>}
 {newKDS>0&&<div style={{padding:'7px 14px',background:C.amberBg,borderRadius:9,border:`1px solid ${C.amberBorder}`}}><span style={{fontSize:12,fontWeight:700,color:C.amber}}>{newKDS} New KDS Orders</span></div>}
 <div style={{padding:'7px 14px',background:C.accentLight,borderRadius:9}}><span style={{fontSize:12,fontWeight:700,color:C.accent}}>Today Total Pax: {Object.values(paxByMeal()).reduce((a,b)=>a+b,0)}</span></div>
 </div>
 </div>
 <div style={{display:'flex',gap:0,overflowX:'auto'}}>
 {KM_TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'10px 14px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`2px solid ${tab===t.id?C.accent:'transparent'}`,whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:5}}>
 {t.icon} {t.label}
 {t.id==='kds'&&newKDS>0&&<span style={{padding:'1px 5px',borderRadius:99,fontSize:10,background:C.redBg,color:C.red}}>{newKDS}</span>}
 {t.id==='inventory'&&lowStock>0&&<span style={{padding:'1px 5px',borderRadius:99,fontSize:10,background:C.amberBg,color:C.amber}}>{lowStock}</span>}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>
 {tab==='dashboard' && <KitchenDashboard kdsOrders={kdsOrders} setKdsOrders={setKdsOrders} stock={stock}/>}
 {tab==='production' && <ProductionSheet stock={stock}/>}
 {tab==='kds' && <KDSModule kdsOrders={kdsOrders} setKdsOrders={setKdsOrders}/>}
 {tab==='inventory' && <KitchenInventory stock={stock} setStock={setStock}/>}
 {tab==='wastage' && <WastageVariance/>}
 {tab==='purchase' && <PurchaseOrders stock={stock}/>}
 {tab==='farm' && <ChefFarmLink/>}
 </div>
 </div>
 );
}
